import type { ReactNode } from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';

interface Props {
  title: string;
  body?: string;
  icon?: LucideIcon;
  actions?: ReactNode;
}

export function Empty({ title, body, icon: Icon = Inbox, actions }: Props) {
  return (
    <div className="text-center px-6 py-10">
      <div
        className="inline-flex items-center justify-center w-10 h-10 rounded-xl mb-3"
        style={{ background: 'var(--surface-2)', color: 'var(--text-3)' }}
      >
        <Icon size={18} strokeWidth={1.6} />
      </div>
      <div className="font-semibold text-[14px] text-text mb-1">{title}</div>
      {body && <div className="text-[13px] text-text-2 max-w-[420px] mx-auto">{body}</div>}
      {actions && <div className="mt-4 flex items-center justify-center gap-2">{actions}</div>}
    </div>
  );
}
